import api from './index';
let exports = {};

// 不分页
exports.getShopAsmblAccIoRecList = function (data, callback) {
    api.post('/asmbl/acc/io/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/asmblAcc.js
// module id = 512
// module chunks = 1